import { projectNameMap } from '@constants'
import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { Image } from '@pets-ui/Image/Image'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { type ReactNode } from 'react'
import { brandImageMap, type BrandInfo } from '../../constants'

const styles = stylex.create({
  root: {
    borderColor: colors.grey300,
    borderStyle: 'solid',
    borderWidth: 1,
    backgroundColor: colors.white,
  },
  selected: {
    borderColor: colors.red600,
    backgroundColor: colors.red50,
  },
})

export interface BrandChipCompactProps {
  brand: BrandInfo
  selected?: boolean
  subtitle?: ReactNode
  onClick?: (brand: BrandInfo) => void
}

export const BrandChipCompact = (props: BrandChipCompactProps) => {
  const { brand, selected, subtitle, onClick } = props
  const avatarSrc = brandImageMap[brand.projectCode]?.avatar
  const brandName = projectNameMap[brand.projectCode] ?? brand.projectCode

  return (
    <HStack
      gap={2}
      alignItems="center"
      p={3}
      borderRadius={4}
      cursor="pointer"
      flexShrink={0}
      rootStyle={[styles.root, selected && styles.selected]}
      onClick={() => onClick?.(brand)}
    >
      {avatarSrc && <Image src={avatarSrc} alt={brandName} width={28} height={28} />}
      <Box>
        <Text variant="subtitle" color={colors.grey800}>{brandName}</Text>
        {subtitle && <Text variant="caption" color={colors.grey500}>{subtitle}</Text>}
      </Box>
    </HStack>
  )
}
